export const BotIcon = () => (
  <svg width={36} height={36} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3.034a18 18 0 1 1 20 29.932A18 18 0 0 1 8 3.034Zm3.143.215c-.591.273-1.164.586-1.714.934v10.183a2.57 2.57 0 0 0 .745 1.817l.969.96V3.249Zm3.428-1.166a15.67 15.67 0 0 0-1.714.48v15.583a1.717 1.717 0 0 0 .497 1.217l1.217 1.208V2.083Zm-5.946 29.21A16.286 16.286 0 0 0 18 34.276v.009a16.286 16.286 0 0 0 0-32.572 16.08 16.08 0 0 0-1.714.095v23.048L8.717 17.29a3.429 3.429 0 0 1-1.003-2.418V5.383a16.286 16.286 0 0 0 .91 25.91ZM18 32.57V3.43a14.571 14.571 0 1 1 0 29.142Zm8.777-8.777a5.143 5.143 0 0 0 1.509-3.634v-3.017l-7.072 7.063a5.142 5.142 0 0 0-1.5 3.643v3.008l7.063-7.063Zm0-7.714a5.142 5.142 0 0 0 1.509-3.634V9.429l-7.072 7.062a5.142 5.142 0 0 0-1.5 3.643v3.009l7.063-7.063Z"
      fill="#1C1C1C"
    />
  </svg>
);
